import axios from 'axios'
import { notification } from 'antd';
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.REACT_APP_BASE_API, // 从环境变量获取基础 API 地址
  timeout: 10000, // 请求超时时间
  withCredentials: false, // 跨域请求时是否需要使用凭证
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 例如：如果需要 token，可以在这里统一设置
    const token = "";//getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // 添加默认参数 aid
    if (config.params) {
      config.params.aid = process.env.REACT_APP_WEB_SITE_ID
    } else {
      config.params = { aid: process.env.REACT_APP_WEB_SITE_ID }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    // 统一处理错误提示
    let errorMessage = '请求失败，请稍后重试';
    if (error.response) {
      errorMessage = error.response.data?.message || error.message;
    } else if (error.request) {
      errorMessage = '网络错误，请检查您的网络连接';
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = '请求超时，请稍后重试';
    } else {
      errorMessage = error.message || '请求失败，请稍后重试';
    }
    notification.error({
      message: '错误提示',
      description: errorMessage,
      duration: 4.5,
    });
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data
    // 这里可以根据后端返回的状态码进行统一处理
    console.log(res)
    if (!res.ok) {
      // 例如：提示错误信息
      return Promise.reject(res.message || 'Error')
    } else {
      return res
    }
  },
  error => {
    // 对响应错误做点什么
    // 例如：处理 HTTP 状态码
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 处理未授权
          break
        case 403:
          // 处理禁止访问
          break
        case 404:
          // 处理未找到
          break
        case 500:
          // 处理服务器错误
          break
      }
    }
    // 统一处理错误提示
    let errorMessage = '请求失败，请稍后重试';
    if (error.response) {
      errorMessage = error.response.data?.message || error.message;
    } else if (error.request) {
      errorMessage = '网络错误，请检查您的网络连接';
    } else if (error.code === 'ECONNABORTED') {
      errorMessage = '请求超时，请稍后重试';
    } else {
      errorMessage = error.message || '请求失败，请稍后重试';
    }
    notification.error({
      message: '错误提示',
      description: errorMessage,
      duration: 4.5,
    });
    return Promise.reject(error)
  }
)

/**
 * 封装 GET 请求
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @param {object} config 额外配置
 */
export function get(url, params = {}, config = {}) {
  return service({
    method: 'get',
    url,
    params,
    ...config
  })
}

/**
 * 封装 POST 请求
 * @param {string} url 请求地址
 * @param {object} data 请求数据
 * @param {object} config 额外配置
 */
export function post(url, data = {}, config = {}) {
  return service({
    method: 'post',
    url,
    data,
    ...config
  }).catch(error => {
    notification.error({
      message: '错误提示',
      description: error.response?.data?.message || error.message,
      duration: 2,
    });
    console.error('请求出错:', error);
  });
}


// 导出其他常用方法
export default {
  get,
  post,
  put: (url, data = {}, config = {}) => service({ method: 'put', url, data, ...config }),
  delete: (url, params = {}, config = {}) => service({ method: 'delete', url, params, ...config }),
  request: service
}